import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper';

const setComSlider = () => {
  const targetSliders = document.querySelectorAll('.js-component-slider');

  targetSliders.forEach((Slider) => {
    const swiper = new Swiper(Slider, {
      modules: [Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 500,
      centeredSlides: true,
      pagination: {
        el: Slider.closest('.component-slider').querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: Slider.closest('.component-slider').querySelector('.swiper-button-next'),
        prevEl: Slider.closest('.component-slider').querySelector('.swiper-button-prev'),
      },
    });
  });
};

export default setComSlider;
